// Copyright (c) 2017 Deere & Company

import CreateClaimModal from '../../../shared/state/create-claim-modal';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateClaimTypes = (state, action) =>
    CreateClaimModal.update(state, {
        claimTypes: {
            $set: action.claimTypes
        }
    });

const updateCreateClaimModal = (state, action) =>
    CreateClaimModal.update(state, {
        $merge: {
            isModalOpen: action.isOpen,
            selectedPin: action.pin
        }
    });

export default (state = getDefaultState().createClaimModal, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_CLAIM_TYPES]: updateClaimTypes,
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_CREATE_CLAIM_MODAL]: updateCreateClaimModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/create-claim-modal.js